const KEY = "kiosk-lock-code";

export const kioskLockCode = () => {
  try { return sessionStorage.getItem(KEY) || ""; } catch { return ""; }
};
export const setKioskLock = (code) => {
  try { code ? sessionStorage.setItem(KEY, code) : sessionStorage.removeItem(KEY); } catch { /* private mode */ }
};

const doc = () => document;
export const fullscreenSupported = () => !!(doc().fullscreenEnabled || doc().webkitFullscreenEnabled);
export const isFullscreen = () => !!(doc().fullscreenElement || doc().webkitFullscreenElement);
export const enterFullscreen = () => {
  const el = document.documentElement;
  const fn = el.requestFullscreen || el.webkitRequestFullscreen;
  try { return Promise.resolve(fn && fn.call(el)).catch(() => {}); } catch { return Promise.resolve(); }
};
export const exitFullscreen = () => {
  const fn = doc().exitFullscreen || doc().webkitExitFullscreen;
  try { if (isFullscreen() && fn) return Promise.resolve(fn.call(doc())).catch(() => {}); } catch { /* noop */ }
  return Promise.resolve();
};
